import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { mapDeviceTypesToTypeaheadSuggestions, getActionTypesResult, USER_STATUSES } from '../utils';

export const typeaheadConstants = {
    TYPEAHEAD_LOADED: 'TYPEAHEAD_LOADED',
    TYPEAHEAD_CLEARED: 'TYPEAHEAD_CLEARED',
    TYPEAHEAD_ADDED: 'TYPEAHEAD_ADDED'
};

export const typeaheadFulfilledConstants = getActionTypesResult(typeaheadConstants, '_FULFILLED');
export const typeaheadRejectedConstants = getActionTypesResult(typeaheadConstants, '_REJECTED');
export const typeaheadPendingConstants = getActionTypesResult(typeaheadConstants, '_PENDING');

export const clearTypeahed = () => ({
    type: typeaheadConstants.TYPEAHEAD_CLEARED
});

export const addedTypeaheadSuggestions = (source, suggestions) => ({
    type: typeaheadConstants.TYPEAHEAD_ADDED,
    payload: {
        source,
        list: suggestions
    }
});

export const fetchTypeaheadUsers =
    createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, (source,
        { term, enableSearchInactiveUsers, userId = null, enableSearchAllUsers },
        statusEmployee = { EmployeeStates: USER_STATUSES.employees }) => {
        if (term || userId) {
            const additionalData =
            enableSearchInactiveUsers ? { EmployeeStates: USER_STATUSES.notEmployees } : statusEmployee;
            const resultData = enableSearchAllUsers ? { EmployeeStates: USER_STATUSES.all } : additionalData;
            const data = { userName: term, userId, ...resultData };
            return api.get(`users/search`, { params: data, paramsSerializer: { indexes: null } }).then(res => ({
                source,
                list: res.data
            }));
        } else {
            return Promise.resolve([]);
        }
    });

export const fetchTypeaheadUsersLicenseReview =
    createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, (source,
        { term, licenseId }) => {
        if (term && licenseId) {
            return api.get(`licenseUserAssignment/${licenseId}/users?userName=${term}`).then(res => ({
                source,
                list: res.data
            }));
        } else {
            return Promise.resolve([]);
        }
    });

export const fetchUsersByNameAndLocationIds = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term, locationsQuery }) => {
        if (!term || !locationsQuery) {
            return Promise.resolve([]);
        }

        return api.get(`users/byNameAndOfficeIds?name=${term}${locationsQuery}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchAllTypeaheadPositionInCompany = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source => api.get(`users/positions`).then(res => ({
    source,
    list: res.data,
}))
);

export const fetchAllTypeaheadRoleOnProject = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source => api.get(`users/roleTypes`).then(res => ({
    source,
    list: res.data,
}))
);

export const fetchAllTypeaheadPrimarySkill = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source => api.get(`users/primarySkills`).then(res => ({
    source,
    list: res.data,
}))
);

export const fetchAllTypeaheadProjectsInCompany = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source => api.get(`projects/all`).then(res => ({
    source,
    list: res.data,
}))
);

export const fetchTypeaheadGeneralCategories = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term, categoryType }) => {
        if (!term || !categoryType) {
            return Promise.resolve([]);
        }

        return api.get(`deviceCategories/search/${categoryType}/${term}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchAllTypeaheadDeviceTypes = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`deviceTypes`).then(res => ({
        source,
        list: mapDeviceTypesToTypeaheadSuggestions(res.data)
    }))
);

export const fetchAllTypeaheadOS = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`deviceSpecifications/operatingSystemNames`).then(res => ({
        source,
        list: res.data.total ? res.data.deviceOperatingSystemNames : []
    }))
);

export const fetchAllTypeaheadProcessorName = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`deviceSpecifications/processorNames`).then(res => ({
        source,
        list: res.data.total ? res.data.deviceProcessorNames : []
    }))
);

export const fetchAllTypeaheadCore = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`deviceSpecifications/processorCores`).then(res => ({
        source,
        list: res.data.total ? res.data.deviceProcessorCores : []
    }))
);

export const fetchAllTypeaheadDiskSize = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`deviceSpecifications/diskSizes`).then(res => ({
        source,
        list: res.data.total ? res.data.deviceDiskSizes : []
    }))
);

export const fetchAllTypeaheadRamSize = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`deviceSpecifications/rams`).then(res => ({
        source,
        list: res.data.total ? res.data.deviceRams : []
    }))
);

export const fetchAllTypeaheadRamSlots = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`deviceSpecifications/ramSlots`).then(res => ({
        source,
        list: res.data.total ? res.data.deviceRamSlots : []
    }))
);

export const fetchAllTypeaheadMobileDeviceTypes = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`mobileDeviceTypes`).then(res => ({
        source,
        list: mapDeviceTypesToTypeaheadSuggestions(res.data)
    }))
);

export const fetchTypeaheadProjects = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, (source, { term }) => {
    if (!term) {
        return Promise.resolve([]);
    }

    return api.get(`projects/name/${term}`).then(res => ({
        source,
        list: res.data
    }));
});

export const fetchTypeaheadDevicesForFilter = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term }) => {
        if (!term) {
            return Promise.resolve([]);
        }

        return api.get(`licenseTypes/devices?productKey=${term}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchTypeaheadInfrastructureUnitForFilter = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term }) => {
        if (!term) {
            return Promise.resolve([]);
        }
        return api.get(`devices/liveSearch?searchData=${term}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchTypeaheadLeasingContractsForFilter = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term }) => {
        if (!term) {
            return Promise.resolve([]);
        }

        return api.get(`leasingContracts/liveSearch?searchData=${term}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchTypeaheadLicenseManufacturers = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term }) => {
        if (!term) {
            return Promise.resolve([]);
        }

        return api.get(`licenseManufacturer/byName?name=${term}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchAllTypeaheadLicenseManufacturers = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`licenseManufacturer`).then(res => ({
        source,
        list: res.data
    }))
);
export const fetchAllTypeaheadDeviceManufacturers = createAsyncAction(typeaheadConstants.TYPEAHEAD_LOADED, source =>
    api.get(`deviceManufacturer`).then(res => ({
        source,
        list: res.data
    }))
);

export const fetchTypeaheadProductsByLicenseManufacturers = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term, values = [] }) => {
        if (!term) {
            return Promise.resolve([]);
        }

        const query = {
            licenseName: term,
            licenseManufacturerIds: values
        };
        return api
            .get(`licenses/byNameAndManufacturer`, {
                params: query, paramsSerializer: { indexes: null }
            })
            .then(res => ({
                source,
                list: res.data
            }));
    }
);

export const fetchTypeaheadProductsByVMTitle = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term }) => {
        if (!term) {
            return Promise.resolve([]);
        }

        return api.get(`vm/byName?name=${term}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchTypeaheadVmLicenseReview = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term, licenseId }) => {
        if (term && licenseId) {
            return api.get(`/licenseVirtualMachineAssignment/${licenseId}/virtualMachines?virtualMachineName=${term}`).then(res => ({
                source,
                list: res.data
            }));
        } else {
            return Promise.resolve([]);
        }
    });

export const fetchTypeaheadIuLicenseReview = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term, licenseId }) => {
        if (term && licenseId) {
            return api.get(`licenseDeviceAssignment/${licenseId}/Devices?searchData=${term}`).then(res => ({
                source,
                list: res.data
            }));
        } else {
            return Promise.resolve([]);
        }
    });

export const fetchLicenseProductNameByName = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term }) => {
        if (!term) {
            return Promise.resolve([]);
        }

        return api.get(`licenseProductName/byName?name=${term}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchLicenseProductVersionByVersion = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term, licenseProductNameId }) => {
        if (!(term && licenseProductNameId)) {
            return Promise.resolve([]);
        }

        return api.get(`licenseProductVersion/byVersion?licenseProductVersion=${term}&licenseProductNameId=${licenseProductNameId}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchLicenseProductAttributeByAttribute = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED,
    (source, { term }) => {
        if (!term) {
            return Promise.resolve([]);
        }

        return api.get(`licenseProductAttribute/byAttribute?attribute=${term}`).then(res => ({
            source,
            list: res.data
        }));
    }
);

export const fetchLicenseEnumData = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED, (source, name) =>
        api.get(`enum/getByFilter?Name=${name}`).then(res => ({
            source,
            list: res.data
        }))
);

export const fetchTicketPrefixEnumData = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED, (source, name) =>
        api.get(`enum/getByFilter?Name=${name}`).then(res => ({
            source,
            list: res.data
        }))
);

export const fetchPaymentFrequencyEnumData = createAsyncAction(
    typeaheadConstants.TYPEAHEAD_LOADED, (source, name) =>
        api.get(`enum/getByFilter?Name=${name}`).then(res => ({
            source,
            list: res.data
        }))
);
